module.exports = __webpack_public_path__ + "static/media/KMH_5040.452a56de.jpg";